import { QuizQuestion, UserWithQuizToNoteDef } from '../../types/quiz/quiz.def';

const prettifyLabels = labels => {
  return labels.map(label => {
    let indexOfSeparation = 0;
    const splittedString = label.split('');
    for (
      let i = parseInt((label.length / 2).toFixed());
      i < label.length;
      i++
    ) {
      if (splittedString[i] === ' ') {
        indexOfSeparation = i;
        break;
      }
    }
    if (label.length >= 50)
      return [
        label.slice(0, indexOfSeparation),
        label.slice(indexOfSeparation)
      ];
    return label;
  });
};

export const formatDataForQuizSummaryChart = (
  users: UserWithQuizToNoteDef[],
  quizId: string,
  questions: Pick<QuizQuestion, 'id' | 'name'>[]
) => {
  const dataToSend = {
    labels: prettifyLabels(questions.map(q => q.name)),
    goodAnswers: [],
    wrongAnswers: [],
    nbStudents: users.length,
    nbStudentsAnsweredQuiz: 0
  };

  const userAnsweredQuiz = users
    .filter(user => user?.quiztonotes?.find(qtn => qtn.quiz === quizId))
    .map(user => ({
      ...user,
      quizToNoteForCurrentQuiz: {
        ...user?.quiztonotes?.find(qtn => qtn.quiz === quizId),
        responses: user?.quiztonotes?.find(qtn => qtn.quiz === quizId).responses
          ? user?.quiztonotes?.find(qtn => qtn.quiz === quizId).responses
          : []
      }
    }));

  questions.forEach(q => {
    const nbOfGoodAnswer = [];
    const nbOfWrongAnswer = [];
    nbOfGoodAnswer.push(
      userAnsweredQuiz.filter(user =>
        user.quizToNoteForCurrentQuiz.responses.find(
          response =>
            response.question.id === q.id && response.isCorrect === true
        )
      ).length
    );
    nbOfWrongAnswer.push(
      userAnsweredQuiz.filter(user =>
        user.quizToNoteForCurrentQuiz.responses.find(
          response =>
            response.question.id === q.id && response.isCorrect !== true
        )
      ).length
    );
    dataToSend.goodAnswers = [...dataToSend.goodAnswers, ...nbOfGoodAnswer];
    dataToSend.wrongAnswers = [...dataToSend.wrongAnswers, ...nbOfWrongAnswer];
    dataToSend.nbStudentsAnsweredQuiz = userAnsweredQuiz.length;
  });
  return dataToSend;
};
